import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ImplementerInitialiserPage } from './implementer-initialiser';
import { ImplementerInitialiserComponent } from '../implementer-initialiser-component/implementer-initialiser-component';
import { SharedModule } from '../../shared/shared.module';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    ImplementerInitialiserPage,
    ImplementerInitialiserComponent,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(ImplementerInitialiserPage),
    SharedModule,
    FoundationModule,
  ],
})
export class ImplementerInitialiserPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-initialiser/implementer-initialiser.module.ts